// extracted by mini-css-extract-plugin
export default {"root":"Heading_root__GWbM-","h1":"Heading_h1__xhYFQ","h2":"Heading_h2__9yTTA","h3":"Heading_h3__tcMc1","h4":"Heading_h4__kIin7","h5":"Heading_h5__6HaqS","h6":"Heading_h6__qE6LH"};